import { gql } from '@apollo/client';

const CLINIC_TICKETS = gql`
  query clinicTickets($filter: ClinicTicketsFilterInput, $limit: Int) {
    clinicTickets(filter: $filter, limit: $limit) {
      id
      ticketId
      status
      facility {
        id
        name
      }
      category
      requestedBy {
        id
        firstName
        lastName
        roles
      }
      appName
      lastSeenTicketComment {
        createdBy {
          id
        }
      }
    }
  }
`;

export default CLINIC_TICKETS;
